import useSWR from "swr";
import { fetcher } from "../fetcher";
import { Placeholder } from "./_components/placeholder";
import { Job, Loader, EmptyState } from "../_components/job/job";

export function Block({ cookie }) {
	const ids = cookie ?? [];
	const hasSome = cookie && cookie.length > 0;

	if (!hasSome) {
		return <Placeholder />;
	}

	return (
		<>
			<h1 className="wp-block-steam-blocks-favorites__title has-fluid-2-font-size">
				Twoje zapisane oferty
			</h1>

			<div className="wp-block-steam-blocks-favorites__content">
				{ids.map((id) => (
					<Record key={id} id={id} />
				))}

				<div className="wp-block-steam-blocks-favorites__footer">
					<span className="has-fluid-5-font-size">
						Szukasz czegoś innego? Zgłoś się do nas, by dostać inne superoferty.
					</span>

					<div className="wp-block-button is-style-banner-primary has-icon__steam-forward">
						<a
							className="wp-block-button__link wp-element-button"
							href="/pl/offers/contact/"
						>
							Zgłoś się
							<span className="wp-block-button__link-icon">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z"></path>
								</svg>
							</span>
						</a>
					</div>
				</div>
			</div>
		</>
	);
}

function Record({ id }) {
	const { data, isLoading } = useSWR(
		`/wp-json/steam-api/job/?id=${id}`,
		fetcher,
		{ errorRetryCount: 0 },
	);

	if (isLoading) return <Loader />;

	if (!data) return <EmptyState offerID={id} />;

	return <Job offer={data} />;
}
